// frontend/src/features/engine/tools/grbas/GRBASTask.jsx

import { useTaskRuntime } from "../../context/TaskRuntimeContext";
import useGRBASTask from "./hooks/useGRBASTask";
import GRBASForm from "./components/GRBASForm";
import GRBASFeedback from "./components/GRBASFeedback";
import GRBASPracticeSurface from "./components/GRBASPracticeSurface";
import PresentedStimulusAudio from "../../components/PresentedStimulusAudio";

export default function GRBASTask() {
  const {
    backPath,
    stimulusSelectionControl,
  } = useTaskRuntime();
  const {
    currentTrial,
    currentSample,
    currentIndex,
    totalSamples,
    loading,
    submitting,
    showFeedback,
    feedbackRows,
    submitEvaluation,
    next,
    isCompleted,
    step,
    isContinuousPractice,
  } = useGRBASTask();
  if (loading) {
    return <p>Loading...</p>;
  }

  if (submitting) {
    return (
      <div className="app-module">
        <p>Saving results...</p>
      </div>
    );
  }

  if (!currentSample && !isCompleted) {
    return <p>No samples available.</p>;
  }

  return (
    <GRBASPracticeSurface
      step={step}
      backPath={backPath}
      isCompleted={isCompleted}
      stimulusSelectionControl={stimulusSelectionControl}
      stimulusContent={(
          <PresentedStimulusAudio trial={currentTrial} sampleLink={currentSample?.sampleLink} presentationKnown={Boolean(currentSample)} />
      )}
      bodyContent={
        !showFeedback ? (
          <GRBASForm onSubmit={submitEvaluation} />
        ) : (
          <GRBASFeedback
            feedbackRows={feedbackRows}
            onNext={next}
            isLastSample={currentIndex + 1 >= totalSamples}
            continueLabel={
              currentIndex + 1 >= totalSamples && isContinuousPractice
                ? "Continue practice"
                : null
            }
          />
        )
      }
    />
  );
}
